(function() {
    'use strict';

    angular
        .module('uwAgenda.global')
        .directive('noResults', NoResultsDirective);

    NoResultsDirective.$inject = [];
    
    function NoResultsDirective() {      
        var directive = {
            restrict: 'E',
            template: "<div class='text-default' translate='no_results'></div>"
        };
        return directive;

       
    }

})();